module.exports = __webpack_public_path__ + "img/microsoft.c1a1b48f.svg";